/* Implements a memory storage backed up by localstorage
If localStorage is not accessible because of AdBlockers or Incognito mode
it falls back to Memory storage */
class SafeStorage {
    session: Map<string, string> = new Map<string, string>();

    get(key: string): string | null | undefined {
        try {
            return localStorage.getItem(key);
        } catch(err) {
            console.warn("Working in anonymous mode", err);
            return this.session.get(key);
        }
    }
    set(key: string, value: string): void {
        try {
            return localStorage.setItem(key, value);
        } catch(err) {
            console.warn("Working in anonymous mode", err);
            this.session.set(key, value);
        }
    }
    clear(): void {
        try {
            return localStorage.clear();
        } catch(err) {
            console.warn("Working in anonymous mode", err);
            this.session.clear();
        }
    }
}

const safeStorage = new SafeStorage(); 
export default safeStorage;